import { Serializable } from '../../core/models/serializable';

export class ActionResultModel implements Serializable<ActionResultModel> {
  fromObject(object: any): ActionResultModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public message: string;
}
